import React from 'react'

import { ChevronIconNew } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'

const LEFT_CHEVRON_STYLE = { transform: 'rotate(-180deg)' }
const RIGHT_BUTTON_STYLE = { marginLeft: -2 }

export type HistoryButtonsLayoutProps = {
  hasBackwardLocation: boolean
  hasForwardLocation: boolean
  backwardLabel: string
  forwardLabel: string
  onClickBackward: () => void
  onClickForward: () => void
}

export default React.memo(function HistoryButtonsLayout({
  hasBackwardLocation,
  hasForwardLocation,
  backwardLabel,
  forwardLabel,
  onClickBackward,
  onClickForward,
}: HistoryButtonsLayoutProps) {
  return (
    <React.Fragment>
      <IconButton
        disabled={!hasBackwardLocation}
        tooltip={backwardLabel}
        tooltipPosition="bottom"
        onClick={onClickBackward}
        className="no-selection"
      >
        <ChevronIconNew style={LEFT_CHEVRON_STYLE} size={16} />
      </IconButton>
      <IconButton
        disabled={!hasForwardLocation}
        style={RIGHT_BUTTON_STYLE}
        tooltip={forwardLabel}
        tooltipPosition="bottom"
        onClick={onClickForward}
        className="no-selection"
      >
        <ChevronIconNew size={16} />
      </IconButton>
    </React.Fragment>
  )
})
